module.exports = __webpack_public_path__ + "img/phone.f5ef3f7d.svg";